/* Kuddy journey ID — persists across pages and syncs to cart for order attribution */
(function () {
  'use strict';

  var JOURNEY_KEY = 'kuddy_journey_id';
  var PROXY = '/apps/kuddy-dev';

  function uid() {
    return Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
  }

  function getJourneyId() {
    try {
      var id = localStorage.getItem(JOURNEY_KEY);
      if (!id) {
        id = uid();
        localStorage.setItem(JOURNEY_KEY, id);
      }
      return id;
    } catch (_) {
      return uid();
    }
  }

  function cleanAttributes(attrs) {
    var out = {};
    Object.keys(attrs || {}).forEach(function (key) {
      var value = attrs[key];
      if (value !== undefined && value !== null && String(value).trim() !== '') {
        out[key] = String(value);
      }
    });
    return out;
  }

  function syncCartAttributes(extra) {
    var attrs = cleanAttributes(Object.assign({ kuddy_journey_id: getJourneyId() }, extra || {}));
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs }),
    }).catch(function () {});
  }

  function setLastTouch(source, productHandle) {
    return syncCartAttributes({
      kuddy_last_touch: source,
      kuddy_last_touch_product: productHandle || '',
    });
  }

  function trackEvent(eventName, extra) {
    var payload = Object.assign({
      event_name: eventName,
      source: (extra && extra.source) || 'storefront',
      journey_id: getJourneyId(),
      session_token: getJourneyId(),
    }, extra || {});

    fetch(PROXY + '/analytics', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }).catch(function () {});
  }

  window.KuddyJourney = {
    getJourneyId: getJourneyId,
    syncCartAttributes: syncCartAttributes,
    setLastTouch: setLastTouch,
    trackEvent: trackEvent,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      syncCartAttributes();
    });
  } else {
    syncCartAttributes();
  }
})();
